/* Menú y buscador del encabezado (JP 2026-09-08).

   El markup lo pinta snippets/al-header.liquid desde el layout, así que esta lógica tiene que
   funcionar TAMBIÉN donde el SPA no corre: /cart, /search, las políticas, etc. Por eso vive en
   su propio archivo y no dentro de allure-tecdoc.js.

   Las búsquedas van a la página de resultados de Shopify, /search (JP 2026-09-16): ahí están
   los productos de la tienda, con filtros, orden y contador. Antes iban a /#buscar/<texto>, que
   solo consultaba números en TecDoc y desde el 2026-09-06 no devolvía nada comprable. Esa ruta
   vieja redirige acá (allure-tecdoc.js), y las fichas TecDoc quedaron como respaldo de la
   página de resultados cuando la tienda no tiene el número. */
(function(){

  function q(sel, ctx){ return (ctx||document).querySelector(sel); }
  function enc(s){ return encodeURIComponent(s); }

  function panel(){ return document.getElementById('al-menu-panel'); }
  function boton(){ return document.getElementById('al-menu-btn'); }

  function menu(abrirlo){
    var p = panel(), v = document.getElementById('al-menu-veil'), b = boton();
    if(!p || !b) return;
    var abrir = (abrirlo === undefined) ? p.hidden : !!abrirlo;
    p.hidden = !abrir;
    if(v) v.hidden = !abrir;
    b.setAttribute('aria-expanded', abrir ? 'true' : 'false');
    document.body.classList.toggle('al-menu-open', abrir);
    if(abrir){
      var f = q('.al-menu-pane.on input', p);
      if(f && window.innerWidth >= 900) f.focus();
    }
  }

  function tab(k){
    var p = panel(); if(!p) return;
    p.querySelectorAll('.al-menu-tab').forEach(function(t){
      var on = t.dataset.tab === k;
      t.classList.toggle('on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    p.querySelectorAll('.al-menu-pane').forEach(function(s){
      s.classList.toggle('on', s.dataset.pane === k);
    });
    var f = q('.al-menu-pane.on input', p);
    if(f && window.innerWidth >= 900) f.focus();
  }

  /* ---------- Búsqueda estricta (JP 2026-09-16) ----------
     Shopify busca con OR: "amortiguador delantero derecho rio" traía 1.000 resultados y se
     ensuciaba desde la fila 17. Pidiendo cada palabra en el título o en un tag
     (title:x OR tag:x) exige TODAS: medido, 23 de 23 correctos, y 7 que la búsqueda normal
     nunca mostraba. Esta sintaxis no está documentada por Shopify: si da 0 o deja de
     filtrar, la página de resultados cae a la búsqueda normal (allure-tecdoc.js) y
     herramientas/qa_buscador_estricto.py avisa.

     - un número de parte u OEM (dígitos y 5+ caracteres) NO pasa por acá: va a la búsqueda
       normal, que lo encuentra en la descripción, con el puente de OEM de respaldo.
     - el año sale de la consulta: los títulos traen rangos ("2012-2016") y Shopify no los
       entiende. Viaja aparte (al_anio) y la página ordena y marca con él, sin descartar.
     - género: "delantera" también busca "delantero" (Shopify junta singular y plural, pero
       no masculino y femenino).
     - sin vocabulario de errores de tipeo, a propósito (JP): una lista así se desactualiza.
       Un error de tipeo da 0 y la página muestra la búsqueda normal con un aviso. */
  var STOP = {de:1, del:1, la:1, las:1, el:1, los:1, lo:1, para:1, por:1, y:1, con:1, al:1,
              en:1, un:1, una:1, unos:1, unas:1, mi:1, mis:1, tu:1, su:1, sus:1, que:1};
  function sinTildes(s){
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function consulta(texto){
    var crudas = String(texto || '').replace(/[\/,;:()"]+/g, ' ').trim().split(/\s+/);
    var palabras = [], anio = '';
    for(var i = 0; i < crudas.length; i++){
      var w = sinTildes(crudas[i].toLowerCase()).replace(/[^a-z0-9.\-]/g, '').replace(/^[.\-]+|[.\-]+$/g, '');
      if(!w) continue;
      var alnum = w.replace(/[^a-z0-9]/g, '');
      if(/^(19|20)\d\d$/.test(alnum)){ anio = alnum; continue; }
      if(/\d/.test(alnum) && alnum.length >= 5) return null;      // número de parte / OEM
      if(STOP[w] || w.length < 2) continue;
      palabras.push(w);
    }
    if(!palabras.length) return null;
    var grupos = palabras.map(function(w){
      var v = [w];
      if(w.length >= 5 && !/\d/.test(w)){
        if(/os$/.test(w)) v.push(w.slice(0, -2) + 'as');
        else if(/as$/.test(w)) v.push(w.slice(0, -2) + 'os');
        else if(/o$/.test(w)) v.push(w.slice(0, -1) + 'a');
        else if(/a$/.test(w)) v.push(w.slice(0, -1) + 'o');
      }
      return '(' + v.map(function(x){ return 'title:' + x + ' OR tag:' + x; }).join(' OR ') + ')';
    });
    return {q: grupos.join(' AND '), anio: anio};
  }
  function urlBusqueda(texto){
    var t = String(texto || '').trim();
    var c = consulta(t);
    if(!c) return '/search?type=product&q=' + enc(t);
    return '/search?type=product&q=' + enc(c.q) + '&al_q=' + enc(t) + (c.anio ? '&al_anio=' + c.anio : '');
  }

  function irABuscar(texto){
    var t = String(texto || '').trim();
    if(!t) return false;
    /* type=product: sin él Shopify mezcla páginas y artículos del blog.
       SIN options[prefix]=last a propósito: no cambia nada ("amortig" da 833 con y sin él) y
       Shopify lo deforma en las URLs de paginación y filtros, así que la página 2 buscaba otra
       cosa que la 1 (992 resultados). Medido 2026-09-16. */
    location.href = urlBusqueda(t);
    return true;
  }

  function buscar(e){
    if(e) e.preventDefault();
    var i = document.getElementById('al-q');
    irABuscar(i ? i.value : '');
    return false;
  }

  function parte(e){
    if(e) e.preventDefault();
    var i = document.getElementById('al-menu-parte');
    if(!i || !i.value.trim()){ if(i) i.focus(); return false; }
    menu(false);
    irABuscar(i.value);
    return false;
  }

  /* El seguimiento lo resuelve el rastreador configurado (por defecto 17track): en la URL,
     la palabra NUMERO se reemplaza por lo que escribió el cliente. */
  function pedido(e){
    if(e) e.preventDefault();
    var form = e && e.target ? e.target : q('.al-menu-pane[data-pane="pedido"] form');
    var i = document.getElementById('al-menu-track');
    var msg = document.getElementById('al-menu-track-msg');
    var n = i ? i.value.trim() : '';
    if(!n){
      if(msg) msg.textContent = 'Escribe primero el número de seguimiento, o consúltanos por WhatsApp.';
      if(i) i.focus();
      return false;
    }
    var url = (form && form.dataset.track) || 'https://www.17track.net/es/track?nums=NUMERO';
    window.open(url.replace('NUMERO', enc(n)), '_blank', 'noopener');
    return false;
  }

  /* Lleva a una sección de la home (quiénes somos). Si no estamos en la home, primero navega:
     esas secciones solo se muestran con body[data-view="home"]. */
  function ir(sel){
    menu(false);
    function baja(){
      var el = document.querySelector(sel);
      if(el) el.scrollIntoView({behavior:'smooth', block:'start'});
    }
    var enHome = (location.pathname === '/' || location.pathname === '');
    if(!enHome){ location.href = '/#home'; return false; }
    if((location.hash || '#home') !== '#home'){ location.hash = '#home'; setTimeout(baja, 400); }
    else baja();
    return false;
  }

  /* El texto de ayuda del buscador se acorta en pantalla chica: el largo no cabe cuando el
     botón de menú comparte la fila. Se recalcula al rotar el teléfono. */
  function ajustarPlaceholder(){
    var i = document.getElementById('al-q');
    if(!i || !i.dataset.phCorto) return;
    i.placeholder = (window.innerWidth < 760) ? i.dataset.phCorto : (i.dataset.phLargo || i.placeholder);
  }

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' || e.keyCode === 27){
      var p = panel();
      if(p && !p.hidden){ menu(false); var b = boton(); if(b) b.focus(); }
    }
  });

  window.addEventListener('resize', ajustarPlaceholder);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ajustarPlaceholder);
  else ajustarPlaceholder();

  window.ALMenu = {menu: menu, tab: tab, buscar: buscar, parte: parte, pedido: pedido, ir: ir,
                  consulta: consulta, urlBusqueda: urlBusqueda};
})();
